import { BackendModel, BackendService } from '../core/backend.service';
import { Telefono } from '../security/user/telefono.model';
import { Email } from '../security/user/email.model';
import { OperationalParametric } from './operationalParametric.model';
import { Direccion } from './direccion.model';
import { Documento } from './documento.model';
import { MontoCompra } from './montoCompra.model';
import * as moment from 'moment';
import { Logo } from './logo.model';

export class Cliente extends BackendModel {

  static path = '/clientes/';


  username: string;
  password: string;
  retryPassword: string;
  name: string;
  lastname: string;
  estado: OperationalParametric;
  nacionalidad: OperationalParametric;
  emisorDocumento: OperationalParametric;
  genero: OperationalParametric;
  tipoDocumento: OperationalParametric;
  tipoUsuario: OperationalParametric;
  situacionIva: OperationalParametric;
  montoCompraActual: MontoCompra;
  personaPoliticamenteExpuesta: boolean;
  documentacionPendiente: boolean;
  nroDocumento: string;
  fechaNacimiento: String;
  cuitCuil: string;
  ocupacion: string;
  direcciones: Direccion[];
  telefonos: Telefono[];
  emails: Email[];
  documentacionRespaldatoria: Documento[];
  documentos: Documento[] = [];
  logos: Logo[] = [];
  observacion: string;
  pais: string;
  provincia: string;
  direccion: string;
  numero: string;
  piso: string;
  departamento: string;
  codPostal: string;
  origen: string;
  ultimaCompra =  moment('01/01/2018', 'DD/MM/YYYY');
  fechaRegistro: Date;
  presupuestoId:number

  isPersonaFisica() {
    return this.situacionIva.id === 5 || this.situacionIva.id === 6;
  }

  constructor(protected backendService: BackendService, model?: Cliente) {
    super(backendService, model);
  }

}



// WEBPACK FOOTER //
// ./src/app/cliente/cliente.model.ts